import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { FavoriteToggle } from '~src/favorites/components/favoriteToggle/FavoriteToggle';
import { CardViewStyles } from '~src/spacesPlatform/components/card/CardViewStyles';
import { CardPopoverWidget, ContentCard, getContentUrlForItem } from '~src/spacesPlatform/components/card/ContentCard';

import { DataRoleTooltip } from '../tooltips/DataRoleTooltip';
import { DataRoleThumbnail } from './DataRoleThumbnail';

export class DataRoleCard extends ContentCard {

  public render() {
    const {
      content, hovered, selected, urls, allowDragAndDrop, addContentFavorite, removeContentFavorite
    } = this.props;
    return (
      <div className={CardViewStyles.Card}>
        <DataRoleThumbnail
          hovered={hovered}
          selected={selected}
          navigateUrl={getContentUrlForItem(content, urls)}
          owner={content.owner}
          urls={urls}
          allowDragAndDrop={allowDragAndDrop}
          aria-label={content.name}
        />
        <div className={CardViewStyles.ActionRow}>
          <span className={CardViewStyles.ActionRowName} title={content.name}>
            { content.name }
          </span>
          <span>
            <CardPopoverWidget
              content={content}
              onTriggerClick={this.handleShowPopover}
              popoverContent={this.renderPopoverContent()}
              title={Messages.dataRoleTooltipTitle()}
            />
          </span>
          <span>
            <FavoriteToggle
              isTabbable={true}
              isFavorite={content.favorite}
              onAddFavorite={() => addContentFavorite({ ...content, contentType: 'dataRole' })}
              onRemoveFavorite={() => removeContentFavorite({ ...content, contentType: 'dataRole' })}
            />
          </span>
          { this.renderActionsMenu() }
        </div>
        <div className={CardViewStyles.CardDescription}>
          {this.getDescription()}
        </div>
      </div>
    );
  }

  private renderPopoverContent = () => <DataRoleTooltip content={this.props.content}
    urls={this.props.urls}
    inProjectSpace={this.props.inProjectSpace}
    inPersonalSpace={this.props.inPersonalSpace}/>;
}
